import React, {Component} from "react";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from '@ckeditor/ckeditor5-build-decoupled-document';

Editor.defaultConfig = {
    toolbar: [ 'fontfamily', 'fontsize', 'fontbackgroundcolor', 'fontcolor', '|', 'bold', 'italic', 'underline', '|','bulletedList', 'numberedList', '|' , 'indent', 'outdent', '|' , 'link', 'blockQuote', '|', 'undo', 'redo' ],
    language: 'fr'
};

class SpecificInputEditorFr extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        this.state = {
            [name]: this.props.blockItem.values[0]
        };

        const e = {target: {name: name, value: this.props.blockItem.values[0]}};
        this.props.onChange(e);

        this.change = this.change.bind(this);
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.onChange(e);
    }

    render() {
        return (
            <div>
                <div className="coreBlockItem-label" style={{marginTop: "5px", fontFamily: "SourceSansPro-bold", color: "rgb(50, 69, 90)", width: "100px", fontSize: "14px", paddingTop: "10px", float: "left"}}>
                    <span>Français</span>
                </div>
                <div className="coreBlockItem-value" style={{width: "calc(100% - 165px)", minWidth: "250px", float: "left", height: "90px;"}}>
                    <div className="value">
                        <div id="toolbar-container"></div>
                        <div style={{backgroundColor: "#FFFFFF"}}>
                            <CKEditor
                                editor={Editor}
                                data={this.props.blockItem.values[0]}
                                onReady={editor => {
                                    // Add the toolbar to the container
                                    const toolbarContainer = document.querySelector('#toolbar-container');
                                    toolbarContainer.appendChild(editor.ui.view.toolbar.element);

                                    window.editor = editor;

                                    editor.editing.view.change((writer) => {
                                        writer.setStyle(
                                            "height",
                                            "100px",
                                            editor.editing.view.document.getRoot()
                                        );
                                    });

                                    // You can store the "editor" and use when it is needed.
                                    console.log('Editor is ready to use!', editor);
                                }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    let inputClassName = 'BLOCK_ITEM_400003';
                                    let element = document.querySelector('.' + inputClassName + ' input');
                                    let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                                    var newData1 = data.replace(/<p>/, "");
                                    var newData2 = newData1.substring(0,newData1.length-4);
                                    nativeInputValueSetter.call(element, newData2);
                                    let ev2 = new Event('input', {bubbles: true});
                                    element.dispatchEvent(ev2);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SpecificInputEditorFr;
